import {
  SET_CONTENT_PROVIDERS
} from 'app/actions/types';

import {
  getContentProviders as getContentProvidersSvc
} from 'app/services/contentProviders';

export const getContentProviders = params => async dispatch => {
  let contentProviders = await getContentProvidersSvc(params);

  if (contentProviders) {
    dispatch({
      type: SET_CONTENT_PROVIDERS,
      payload: contentProviders.params
    });
  }

  return contentProviders;
}

export const setContentProviderParams = params => async dispatch => {
  dispatch({
    type: SET_CONTENT_PROVIDERS,
    payload: params
  });
}
